// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"805":"ba3bfc47","998":"3936ace9"}[chunkId] + ".chunk.js");